module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "background-color": "lightgray",
      "padding": "10px",
      "width": "200px",
      "position": "fixed",
      "height": "100vh"
    }
  }, [_vm._l((_vm.components), function(component, index) {
    return _c('div', [_c('button', {
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_vm._v(_vm._s(component.name))])])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "descripton"
  }, [_vm._v(_vm._s(_vm.currentComponent.description))])], 2), _vm._v(" "), _c('div', {
    staticClass: "component_container"
  }, [_c(_vm.currentComponent, {
    tag: "component"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0031812d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ComponentViewer.vue
// module id = 1427
// module chunks = 1